import { IconGlobal } from "@/components/design-system/icons/IconGlobal";
import { IconNetworking } from "@/components/design-system/icons/IconNetworking";
import { IconRock } from "@/components/design-system/icons/IconRock";
import { IconInstant } from "@/components/design-system/icons/IconInstant";
import { type BenefitItem } from "@/components/design-system/BenefitCard/BenefitCard";

export const benefits: readonly BenefitItem[] = [
  {
    Icon: IconGlobal,
    title: "Show Up Where Your Members Are",
    description:
      "Your members are turning to AI for financial guidance. Bravo makes sure it comes from their credit union — grounded in their accounts and aligned with their goals.",
  },
  {
    Icon: IconNetworking,
    title: "Reach the Members You've Been Missing",
    description:
      "The members who need help most are the least likely to ask. Bravo meets them privately, on their terms — no appointments, no judgment.",
  },
  {
    Icon: IconRock,
    title: "Engagement That Actually Sticks",
    description:
      "Static portals get a single visit. Conversational AI builds an ongoing relationship — every interaction is relevant, personal, and gets smarter over time.",
  },
  {
    Icon: IconInstant,
    title: "Compliant From Day One",
    description:
      "Educational guardrails, configurable disclosures, and audit-ready logging — so your team can move fast without creating compliance exposure.",
  },
];
